const { useState, useEffect } = React;

// ── Shape SVGs
const SHP = {
  Round:    React.createElement('svg', {viewBox:"0 0 60 60",fill:"none",stroke:"currentColor",strokeWidth:"1.5"}, React.createElement('circle',{cx:30,cy:30,r:20}), React.createElement('line',{x1:30,y1:10,x2:30,y2:50}), React.createElement('line',{x1:10,y1:30,x2:50,y2:30})),
  Princess: React.createElement('svg', {viewBox:"0 0 60 60",fill:"none",stroke:"currentColor",strokeWidth:"1.5"}, React.createElement('rect',{x:12,y:12,width:36,height:36}), React.createElement('line',{x1:12,y1:12,x2:48,y2:48}), React.createElement('line',{x1:48,y1:12,x2:12,y2:48})),
  Oval:     React.createElement('svg', {viewBox:"0 0 60 60",fill:"none",stroke:"currentColor",strokeWidth:"1.5"}, React.createElement('ellipse',{cx:30,cy:30,rx:15,ry:22}), React.createElement('line',{x1:30,y1:8,x2:30,y2:52})),
  Cushion:  React.createElement('svg', {viewBox:"0 0 60 60",fill:"none",stroke:"currentColor",strokeWidth:"1.5"}, React.createElement('path',{d:"M14,20 Q14,12 22,12 L38,12 Q46,12 46,20 L46,40 Q46,48 38,48 L22,48 Q14,48 14,40 Z"})),
  Emerald:  React.createElement('svg', {viewBox:"0 0 60 60",fill:"none",stroke:"currentColor",strokeWidth:"1.5"}, React.createElement('polygon',{points:"20,10 40,10 50,20 50,40 40,50 20,50 10,40 10,20"}), React.createElement('rect',{x:18,y:18,width:24,height:24})),
  Radiant:  React.createElement('svg', {viewBox:"0 0 60 60",fill:"none",stroke:"currentColor",strokeWidth:"1.5"}, React.createElement('polygon',{points:"18,10 42,10 50,18 50,42 42,50 18,50 10,42 10,18"})),
  Asscher:  React.createElement('svg', {viewBox:"0 0 60 60",fill:"none",stroke:"currentColor",strokeWidth:"1.5"}, React.createElement('polygon',{points:"20,10 40,10 50,20 50,40 40,50 20,50 10,40 10,20"}), React.createElement('polygon',{points:"22,18 38,18 42,22 42,38 38,42 22,42 18,38 18,22"})),
  Marquise: React.createElement('svg', {viewBox:"0 0 60 60",fill:"none",stroke:"currentColor",strokeWidth:"1.5"}, React.createElement('path',{d:"M30,8 Q50,30 30,52 Q10,30 30,8Z"})),
  Heart:    React.createElement('svg', {viewBox:"0 0 60 60",fill:"none",stroke:"currentColor",strokeWidth:"1.5"}, React.createElement('path',{d:"M30,48 Q10,36 10,22 Q10,12 20,12 Q26,12 30,18 Q34,12 40,12 Q50,12 50,22 Q50,36 30,48Z"})),
  Pear:     React.createElement('svg', {viewBox:"0 0 60 60",fill:"none",stroke:"currentColor",strokeWidth:"1.5"}, React.createElement('path',{d:"M30,50 Q14,38 14,26 Q14,10 30,10 Q46,10 46,26 Q46,38 30,50Z"})),
  Trilliant:React.createElement('svg', {viewBox:"0 0 60 60",fill:"none",stroke:"currentColor",strokeWidth:"1.5"}, React.createElement('polygon',{points:"30,8 52,48 8,48"})),
  Baguette: React.createElement('svg', {viewBox:"0 0 60 60",fill:"none",stroke:"currentColor",strokeWidth:"1.5"}, React.createElement('rect',{x:20,y:8,width:20,height:44}), React.createElement('line',{x1:24,y1:12,x2:24,y2:48}), React.createElement('line',{x1:36,y1:12,x2:36,y2:48})),
};

/* Shape buttons. Related cuts fold together: Baguillion under Baguette,
   Old Mine under Cushion, Square Emerald under Asscher. Anything not listed
   here (trapezoid, half moon, kite, bullet, cadi) keeps its own name — it still
   appears in results, it just has no button of its own. */
const SHAPES=['Round','Princess','Cushion','Emerald','Oval','Radiant','Asscher','Marquise','Heart','Pear','Trilliant','Baguette'];

const SHAPE_MAP={
  'Round Brilliant':'Round',
  'Square Radiant':'Radiant',
  'Octangonal':'Radiant',
  'Square Emerald':'Asscher',
  'Baguillion':'Baguette',
  'Tapered Baguette':'Baguette',
  'Old Mine':'Cushion'
};

/* Shape values aren't perfectly consistent — some stones are recorded as
   "Pear Shape" or "Emerald Cut" rather than "Pear" or "Emerald". Strip those
   suffixes before matching. An unrecognised shape is returned unchanged so it
   still lists; it simply won't match any button. */
function normShape(s){
  const v=(s||'').trim();
  if(!v) return '';
  if(SHAPE_MAP[v]) return SHAPE_MAP[v];
  if(SHAPES.indexOf(v)!==-1) return v;
  const stripped=v.replace(/\s+(shape|cut)$/i,'').trim();
  if(SHAPE_MAP[stripped]) return SHAPE_MAP[stripped];
  if(SHAPES.indexOf(stripped)!==-1) return stripped;
  return v;
}

/* Colour scale. D-K are the standard grades; FANCY catches everything else —
   L and below, the U-V / S-T / W-X ranges, and all fancy colours. Matched pairs
   are graded like "F/G", so we take the first grade and place them on the normal
   scale rather than letting them fall into Fancy. */
const FANCY='Fancy';
const WHITE_COLORS=['D','E','F','G','H','I','J','K'];
const COLORS=[...WHITE_COLORS, FANCY];
function colourIndex(v){
  let s=(v||'').trim();
  if(s.indexOf('/')!==-1) s=s.split('/')[0].trim();   // "F/G" → F
  const i=WHITE_COLORS.indexOf(s);
  return i===-1 ? WHITE_COLORS.length : i;
}

const CLARITIES=['FL','IF','VVS1','VVS2','VS1','VS2','SI1','SI2','I1','I2'];
const CUTS=['Excellent','Very Good','Good','Medium'];

const CARAT_MIN=0.1, CARAT_MAX=10;
const PRICE_MIN=0, PRICE_MAX=350000;
const ENQUIRY_EMAIL='diamonds@diamondimports.com.au';

const ALLOWED_TYPES=['Loose Diamond'];
function isAllowed(t){return ALLOWED_TYPES.indexOf((t||'').trim())!==-1;}

function getMF(p){return p.mf||{};}

// A matched pair is titled "... Pair(s) ..." and graded across two stones ("F/G")
function isPair(p){
  if(/pairs?\b/i.test(p.title||'')) return true;
  return ((getMF(p).colour)||'').indexOf('/')!==-1;
}

// ── Storefront API. Public token — read-only, safe to expose client-side.
const SF_DOMAIN='pwie0b-8y.myshopify.com';
const SF_TOKEN='dca974f988e0a4d44b925543b80d30ef';
const SF_VERSION='2025-10';
const SF_COLLECTION='diamond-gemstone-search';
const SF_PAGE_SIZE=250;
const SF_MAX_PAGES=25;
const MF_KEYS=['shape','colour','clarity','cut','carat','polish','symmetry','fluorescence','certificate','table','depth','width','length','girdle','culet','in_stock_now'];

const SF_QUERY=`
query Diamonds($handle:String!,$first:Int!,$cursor:String){
  collection(handle:$handle){
    products(first:$first,after:$cursor){
      pageInfo{hasNextPage endCursor}
      nodes{
        id handle title productType
        featuredImage{ url(transform:{maxWidth:500,maxHeight:500}) }
        priceRange{ minVariantPrice{ amount } }
        metafields(identifiers:[${MF_KEYS.map(k=>`{namespace:"custom",key:"${k}"}`).join(',')}]){ key value }
      }
    }
  }
}`;

function mapNode(n){
  const mf={};
  (n.metafields||[]).forEach(m=>{ if(m&&m.value) mf[m.key]=m.value; });
  return {
    id:n.id, handle:n.handle, title:n.title, productType:n.productType,
    featuredImage:n.featuredImage?n.featuredImage.url:null,
    price:parseFloat(n.priceRange&&n.priceRange.minVariantPrice?n.priceRange.minVariantPrice.amount:0)||0,
    mf
  };
}

async function fetchPage(cursor){
  const res=await fetch(`https://${SF_DOMAIN}/api/${SF_VERSION}/graphql.json`,{
    method:'POST',
    headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':SF_TOKEN},
    body:JSON.stringify({query:SF_QUERY,variables:{handle:SF_COLLECTION,first:SF_PAGE_SIZE,cursor}})
  });
  if(!res.ok) throw new Error(`Storefront API ${res.status}`);
  const json=await res.json();
  if(json.errors&&json.errors.length) throw new Error(json.errors[0].message);
  const c=json.data&&json.data.collection;
  if(!c) throw new Error('Collection not found');
  return {
    nodes:c.products.nodes.filter(n=>isAllowed(n.productType)).map(mapNode),
    pageInfo:c.products.pageInfo
  };
}

function parseCt(v){return v?parseFloat(String(v).replace(/[^0-9.]/g,''))||0:0;}
function parsePct(v){const m=(v||'').match(/(\d+\.?\d*)%/);return m?parseFloat(m[1]):0;}

// Clarity and cut: an unrecognised or missing grade should not hide a stone.
function inRange(scale, range, value){
  if(!range) return true;
  const i=scale.indexOf((value||'').trim());
  if(i===-1) return true;
  const a=scale.indexOf(range[0]), b=scale.indexOf(range[1]);
  return i>=Math.min(a,b) && i<=Math.max(a,b);
}

// Colour: every stone lands somewhere, so there is no free pass.
function colourInRange(range, value){
  if(!range) return true;
  const i=colourIndex(value);
  const a=COLORS.indexOf(range[0]), b=COLORS.indexOf(range[1]);
  return i>=Math.min(a,b) && i<=Math.max(a,b);
}

const CSS=`
*{box-sizing:border-box}
@keyframes fadeUp{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}
@keyframes dfspin{to{transform:rotate(360deg)}}
.ci{animation:fadeUp .22s ease both}
input[type=range]{-webkit-appearance:none;appearance:none}
.df-wrap{background:#faf8f4;min-height:100vh;color:#1a1a2e;font-family:'Lato','Helvetica Neue',sans-serif}
.df-inner{max-width:1500px;margin:0 auto;padding:0 20px}
.df-shaperow{padding:26px 0 6px}
.df-panel2,.df-panel3{display:grid;grid-template-columns:1fr;gap:0 44px}
@media(min-width:900px){
  .df-panel2{grid-template-columns:1fr 1fr}
  .df-panel3{grid-template-columns:1fr 1fr 1fr}
}
.df-group{margin-bottom:26px}
.df-label{font-size:12px;font-weight:700;letter-spacing:.11em;text-transform:uppercase;color:#1a1a2e;margin-bottom:4px}
.df-hint{font-size:11px;color:#a8a296;margin-bottom:11px}
.df-shapes{display:grid;grid-template-columns:repeat(auto-fit,minmax(78px,1fr));gap:6px}
@media(min-width:1100px){.df-shapes{grid-template-columns:repeat(12,1fr)}}
.df-shape{display:flex;flex-direction:column;align-items:center;gap:7px;padding:12px 2px;border:1.5px solid transparent;border-radius:8px;cursor:pointer;background:none;transition:all .14s}
.df-shape:hover{background:#f2ede3}
.df-shape.on{border-color:#1a1a2e;background:#faf7f0}
.df-shape svg{width:44px;height:44px;stroke-width:2;color:#4a4a58;transition:color .14s}
.df-shape.on svg{color:#c8a840}
.df-shape span{font-size:11.5px;color:#3d3d4a;white-space:nowrap}
.df-shape.on span{font-weight:700;color:#1a1a2e}
.df-scale{display:flex;gap:4px}
.df-scale button{flex:1;padding:8px 2px;border-radius:5px;font-size:12px;border:1.5px solid #ddd;background:#fff;color:#777;cursor:pointer;font-family:inherit;transition:all .12s;white-space:nowrap}
.df-scale button:hover{border-color:#c0b898}
.df-scale button.on{border-color:#d4af37;background:#1a1a2e;color:#d4af37;font-weight:700}
.df-scale button.fancy{flex:1.4;font-size:11px}
.df-num{display:flex;gap:10px;margin-bottom:12px}
.df-num input{flex:1;min-width:0;padding:9px 8px;border:1.5px solid #d0c8bc;border-radius:5px;font-size:14px;color:#1a1a2e;font-family:inherit;text-align:center;background:#fff;outline:none}
.df-num input:focus{border-color:#d4af37}
.df-bar{display:flex;align-items:center;gap:16px;flex-wrap:wrap;padding:16px 0;border-top:1px solid #e8e0d4;margin-top:4px}
.df-switch{display:flex;align-items:center;gap:9px;font-size:12.5px;white-space:nowrap}
.df-btn{padding:9px 18px;border:1.5px solid #d0c8bc;border-radius:6px;background:#fff;font-size:12px;color:#1a1a2e;cursor:pointer;font-family:inherit;white-space:nowrap}
.df-btn:hover{border-color:#1a1a2e}
.df-loading{display:flex;align-items:center;gap:7px;font-size:11.5px;color:#a8a296;white-space:nowrap}
.df-spinner{width:13px;height:13px;border:2px solid #e8e0c8;border-top-color:#d4af37;border-radius:50%;animation:dfspin .8s linear infinite}
.df-error{background:#fdf4f4;border:1px solid #e8cfcf;color:#8a4a4a;font-size:12px;padding:11px 15px;border-radius:6px;margin:14px 0}
.df-adv{padding:18px 0 4px;border-top:1px solid #e8e0d4}
.df-advgrid{display:grid;grid-template-columns:1fr;gap:0 44px}
@media(min-width:900px){.df-advgrid{grid-template-columns:1fr 1fr}}
.df-toggle{display:flex;justify-content:space-between;align-items:center;padding:11px 0;border-bottom:1px solid #f0ebe0}
.df-grid{display:grid;gap:14px;grid-template-columns:repeat(2,1fr);padding:18px 0 0}
@media(min-width:600px){.df-grid{grid-template-columns:repeat(3,1fr)}}
@media(min-width:900px){.df-grid{grid-template-columns:repeat(4,1fr)}}
@media(min-width:1100px){.df-grid{grid-template-columns:repeat(6,1fr)}}
.df-pairbadge{position:absolute;bottom:6px;left:6px;background:rgba(255,255,255,.92);color:#1a1a2e;font-size:8px;font-weight:700;padding:2px 6px;border-radius:2px;border:1px solid #e8e0c8;letter-spacing:.06em}

/* ── Detail popup (landscape) */
.df-overlay{position:fixed;inset:0;background:rgba(10,10,25,.72);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;backdrop-filter:blur(4px)}
.df-modal{position:relative;background:#fff;border-radius:12px;width:100%;max-width:1020px;max-height:90vh;overflow:hidden;display:grid;grid-template-columns:1fr;box-shadow:0 40px 80px rgba(0,0,0,.35)}
@media(min-width:820px){.df-modal{grid-template-columns:1.02fr 1fr}}
.df-modalimg{background:#f5f2ec;display:flex;align-items:center;justify-content:center;padding:26px;max-height:40vh}
@media(min-width:820px){.df-modalimg{max-height:90vh;padding:34px}}
.df-modalimg img{max-width:100%;max-height:100%;object-fit:contain}
.df-modalbody{padding:28px 30px 30px;overflow-y:auto;max-height:90vh}
.df-close{position:absolute;top:12px;right:14px;background:rgba(255,255,255,.85);border:none;width:32px;height:32px;border-radius:50%;font-size:20px;color:#666;cursor:pointer;line-height:1;z-index:3}
.df-close:hover{color:#1a1a2e}
.df-eyebrow{font-size:9.5px;color:#bbb;text-transform:uppercase;letter-spacing:.12em;margin-bottom:5px}
.df-title{margin:0 0 14px;font-size:24px;color:#1a1a2e;font-family:'Cormorant Garamond',serif;font-weight:600;line-height:1.25}
.df-chips{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:16px}
.df-chip{padding:7px 13px;border:1px solid #e4dccc;border-radius:5px;font-size:12.5px;background:#faf8f4;white-space:nowrap}
.df-cert{font-size:12px;color:#8a8478;padding-bottom:16px;border-bottom:1px solid #f0ebe0;margin-bottom:16px}
.df-price{font-family:'Cormorant Garamond',serif;font-size:32px;font-weight:700;color:#1a1a2e;margin-bottom:18px}
.df-poa{font-size:15px;color:#a8a296;font-style:italic;margin-bottom:18px}
.df-cta{display:flex;gap:10px;flex-wrap:wrap;margin-bottom:22px}
.df-cta a{flex:1 1 160px;text-align:center;padding:14px 16px;border-radius:6px;font-size:12px;font-weight:700;letter-spacing:.07em;text-decoration:none;white-space:nowrap}
.df-cta a.primary{background:#1a1a2e;color:#d4af37}
.df-cta a.secondary{border:1.5px solid #1a1a2e;color:#1a1a2e}
.df-specs{display:grid;grid-template-columns:1fr 1fr;gap:1px;background:#f0ebe0;border:1px solid #f0ebe0;border-radius:8px;overflow:hidden}
.df-specs>div{background:#fff;padding:10px 13px}
.df-specs .k{font-size:9px;color:#bbb;text-transform:uppercase;letter-spacing:.07em;margin-bottom:2px}
.df-specs .v{font-size:12.5px;color:#1a1a2e;font-weight:500}
`;

function Group({label,hint,children}){
  return React.createElement('div',{className:'df-group'},
    React.createElement('div',{className:'df-label'},label),
    hint&&React.createElement('div',{className:'df-hint'},hint),
    children
  );
}

function DualSlider({min,max,step,value,onChange,fmt}){
  const lo=Math.min(value[0],value[1]),hi=Math.max(value[0],value[1]);
  const pct=v=>((v-min)/(max-min))*100;
  return React.createElement('div',null,
    React.createElement('div',{className:'df-num'},
      [0,1].map(i=>React.createElement('input',{key:i,type:'number',value:value[i],step,min,max,onChange:e=>{const v=[...value];v[i]=parseFloat(e.target.value);if(isNaN(v[i]))v[i]=i===0?min:max;onChange(v);}}))
    ),
    React.createElement('div',{style:{position:'relative',height:4,background:'#e8e0c8',borderRadius:2,margin:'10px 8px 0'}},
      React.createElement('div',{style:{position:'absolute',height:'100%',background:'#d4af37',borderRadius:2,left:`${pct(lo)}%`,width:`${pct(hi)-pct(lo)}%`}}),
      [0,1].map(i=>React.createElement('input',{key:i,type:'range',min,max,step,value:value[i],onChange:e=>{const v=[...value],nv=parseFloat(e.target.value);v[i]=i===0?Math.min(nv,value[1]-step):Math.max(nv,value[0]+step);onChange(v);},style:{position:'absolute',inset:'-9px 0',width:'100%',height:22,opacity:0,cursor:'pointer',zIndex:i+1}})),
      [lo,hi].map((v,i)=>React.createElement('div',{key:i,style:{position:'absolute',top:'50%',left:`${pct(v)}%`,transform:'translate(-50%,-50%)',width:15,height:15,background:'#1a1a2e',border:'2px solid #d4af37',borderRadius:'50%',pointerEvents:'none',zIndex:3}}))
    ),
    React.createElement('div',{style:{display:'flex',justifyContent:'space-between',marginTop:9,fontSize:10.5,color:'#a8a296'}},
      React.createElement('span',null,fmt?fmt(min):min),
      React.createElement('span',null,fmt?fmt(max):max)
    )
  );
}

function Scale({opts,value,onChange,wide}){
  const has=Array.isArray(value)&&value.length===2;
  const a=has?opts.indexOf(value[0]):-1;
  const b=has?opts.indexOf(value[1]):-1;
  const lo=has?Math.min(a,b):-1;
  const hi=has?Math.max(a,b):-1;
  const click=(o,i)=>{
    if(!has){onChange([o,o]);return;}
    if(i<lo){onChange([o,opts[hi]]);return;}
    if(i>hi){onChange([opts[lo],o]);return;}
    if(lo===hi){onChange(null);return;}
    if(i===lo){onChange([opts[lo+1],opts[hi]]);return;}
    if(i===hi){onChange([opts[lo],opts[hi-1]]);return;}
    onChange([o,o]);
  };
  return React.createElement('div',{className:'df-scale'},
    opts.map((o,i)=>React.createElement('button',{
      key:o,
      className:[(has&&i>=lo&&i<=hi)?'on':'', wide===o?'fancy':''].filter(Boolean).join(' '),
      onClick:()=>click(o,i)
    },o))
  );
}

function Chips({opts,value,onChange}){
  return React.createElement('div',{style:{display:'flex',flexWrap:'wrap',gap:5,padding:'2px 0 10px'}},
    opts.map(o=>{
      const sel=value.includes(o);
      return React.createElement('button',{key:o,onClick:()=>onChange(sel?value.filter(v=>v!==o):[...value,o]),style:{padding:'6px 12px',borderRadius:4,fontSize:11.5,fontWeight:sel?700:400,border:`1.5px solid ${sel?'#d4af37':'#ddd'}`,background:sel?'#1a1a2e':'white',color:sel?'#d4af37':'#777',cursor:'pointer',fontFamily:'inherit'}},o);
    })
  );
}

function Tog({on,set}){
  return React.createElement('div',{onClick:()=>set(!on),style:{width:38,height:21,borderRadius:11,background:on?'#1a1a2e':'#ddd',position:'relative',cursor:'pointer',transition:'background .2s',flexShrink:0}},
    React.createElement('div',{style:{position:'absolute',top:2.5,left:on?19:2.5,width:16,height:16,borderRadius:'50%',background:on?'#d4af37':'white',transition:'left .2s',boxShadow:'0 1px 3px rgba(0,0,0,.2)'}})
  );
}

function Card({p,onClick}){
  const mf=getMF(p),price=p.price;
  const cert=(mf.certificate||'').includes('GIA')?'GIA':(mf.certificate||'').includes('DCLA')?'DCLA':(mf.certificate||'').includes('IGI')?'IGI':'';
  const[hov,setHov]=useState(false);
  const shape=normShape(mf.shape||'Round');
  const pair=isPair(p);
  return React.createElement('div',{onClick,onMouseEnter:()=>setHov(true),onMouseLeave:()=>setHov(false),style:{background:'white',border:`1px solid ${hov?'#d4af37':'#e8e0c8'}`,borderRadius:8,overflow:'hidden',cursor:'pointer',transition:'all .2s',transform:hov?'translateY(-2px)':'none',boxShadow:hov?'0 8px 24px rgba(26,26,46,.12)':'0 2px 6px rgba(26,26,46,.04)'}},
    React.createElement('div',{style:{background:'#f5f2ec',aspectRatio:'1',position:'relative',overflow:'hidden',display:'flex',alignItems:'center',justifyContent:'center'}},
      p.featuredImage?React.createElement('img',{src:p.featuredImage,alt:p.title,loading:'lazy',style:{width:'100%',height:'100%',objectFit:'cover'}}):React.createElement('div',{style:{width:52,height:52,color:'#c8b87a',opacity:.4}},SHP[shape]||SHP.Round),
      mf.in_stock_now&&React.createElement('div',{style:{position:'absolute',top:6,left:6,background:'#1a1a2e',color:'#d4af37',fontSize:8,fontWeight:700,padding:'2px 6px',borderRadius:2,letterSpacing:'.08em'}},'IN STOCK'),
      cert&&React.createElement('div',{style:{position:'absolute',top:6,right:6,background:'rgba(255,255,255,.92)',color:'#1a1a2e',fontSize:8,fontWeight:700,padding:'2px 6px',borderRadius:2,border:'1px solid #e8e0c8'}},cert),
      pair&&React.createElement('div',{className:'df-pairbadge'},'MATCHED PAIR')
    ),
    React.createElement('div',{style:{padding:'11px 13px'}},
      React.createElement('div',{style:{fontSize:9.5,color:'#a8a296',marginBottom:3,textTransform:'uppercase',letterSpacing:'.06em'}},`${mf.shape||''}${mf.carat?' · '+mf.carat:''}`),
      React.createElement('div',{style:{fontSize:14,color:'#1a1a2e',fontWeight:500,lineHeight:1.3,fontFamily:"'Cormorant Garamond',serif",marginBottom:mf.cut?3:2}},mf.colour&&mf.clarity?`${mf.colour} · ${mf.clarity}`:(p.title.split(' - ')[1]||'')),
      mf.cut&&React.createElement('div',{style:{fontSize:10.5,color:'#a8a296',marginBottom:7}},`${mf.cut} Cut`),
      React.createElement('div',{style:{borderTop:'1px solid #f5f0e8',paddingTop:8,display:'flex',justifyContent:'space-between',alignItems:'center'}},
        price>0?React.createElement('div',{style:{fontSize:15,fontWeight:700,color:'#1a1a2e',fontFamily:"'Cormorant Garamond',serif"}},`A$${price.toLocaleString('en-AU',{maximumFractionDigits:0})}`):React.createElement('div',{style:{fontSize:10.5,color:'#bbb',fontStyle:'italic'}},'Price on application'),
        React.createElement('div',{style:{fontSize:9,color:'#d4af37',fontWeight:700,letterSpacing:'.06em'}},'VIEW →')
      )
    )
  );
}

function Modal({p,onClose}){
  useEffect(()=>{
    const esc=e=>{if(e.key==='Escape')onClose();};
    window.addEventListener('keydown',esc);
    return ()=>window.removeEventListener('keydown',esc);
  },[onClose]);
  if(!p)return null;
  const mf=getMF(p),price=p.price;
  const shape=normShape(mf.shape||'Round');
  const chips=[isPair(p)?'Matched pair':null,mf.carat,mf.shape,mf.colour&&`${mf.colour} Colour`,mf.clarity&&`${mf.clarity} Clarity`,mf.cut&&`${mf.cut} Cut`].filter(Boolean);
  const specs=[['Polish',mf.polish],['Symmetry',mf.symmetry],['Fluorescence',mf.fluorescence],['Table',mf.table],['Depth',mf.depth],['Width',mf.width],['Length',mf.length],['Girdle',mf.girdle],['Culet',mf.culet],['In Stock',mf.in_stock_now]].filter(([,v])=>v);
  const subject=encodeURIComponent(`Enquiry: ${p.title}`);

  return React.createElement('div',{className:'df-overlay',onClick:onClose},
    React.createElement('div',{className:'df-modal',onClick:e=>e.stopPropagation()},
      React.createElement('button',{className:'df-close',onClick:onClose,'aria-label':'Close'},'×'),
      React.createElement('div',{className:'df-modalimg'},
        p.featuredImage
          ? React.createElement('img',{src:p.featuredImage,alt:p.title})
          : React.createElement('div',{style:{width:120,height:120,color:'#c8b87a',opacity:.4}},SHP[shape]||SHP.Round)
      ),
      React.createElement('div',{className:'df-modalbody'},
        React.createElement('div',{className:'df-eyebrow'},'Diamond Imports · Sydney'),
        React.createElement('h2',{className:'df-title'},p.title),
        chips.length>0&&React.createElement('div',{className:'df-chips'},
          chips.map(c=>React.createElement('span',{key:c,className:'df-chip'},c))
        ),
        mf.certificate&&React.createElement('div',{className:'df-cert'},`Certificate · ${mf.certificate}`),
        price>0
          ? React.createElement('div',{className:'df-price'},`A$${price.toLocaleString('en-AU',{maximumFractionDigits:0})}`)
          : React.createElement('div',{className:'df-poa'},'Price on application'),
        React.createElement('div',{className:'df-cta'},
          React.createElement('a',{className:'primary',href:`/products/${p.handle}`},'VIEW FULL DETAILS'),
          React.createElement('a',{className:'secondary',href:`mailto:${ENQUIRY_EMAIL}?subject=${subject}`},'ENQUIRE')
        ),
        specs.length>0&&React.createElement('div',{className:'df-specs'},
          specs.map(([k,v])=>React.createElement('div',{key:k},
            React.createElement('div',{className:'k'},k),
            React.createElement('div',{className:'v'},v)
          ))
        )
      )
    )
  );
}

function DiamondFinder(){
  const[raw,setRaw]=useState(()=>(window._diamondData||[]).filter(p=>isAllowed(p.productType)));
  const[loading,setLoading]=useState(true);
  const[loadError,setLoadError]=useState(null);

  useEffect(()=>{
    let cancelled=false;
    (async()=>{
      try{
        let cursor=null, all=[], pages=0;
        while(pages<SF_MAX_PAGES){
          const {nodes,pageInfo}=await fetchPage(cursor);
          if(cancelled)return;
          all=all.concat(nodes);
          setRaw(all);
          pages++;
          if(!pageInfo.hasNextPage)break;
          cursor=pageInfo.endCursor;
        }
        if(!cancelled)setLoading(false);
      }catch(err){
        if(cancelled)return;
        console.error('Diamond finder: Storefront API load failed',err);
        setLoadError(err.message||'Could not load the full diamond list');
        setLoading(false);
      }
    })();
    return()=>{cancelled=true;};
  },[]);

  const[sel,setSel]=useState(null);
  const[shapes,setShapes]=useState([]);
  const[carat,setCarat]=useState([CARAT_MIN,CARAT_MAX]);
  const[price,setPrice]=useState([PRICE_MIN,PRICE_MAX]);
  const[colour,setColour]=useState(null);
  const[clarity,setClarity]=useState(null);
  const[cut,setCut]=useState(null);
  const[adv,setAdv]=useState(false);
  const[polOn,setPolOn]=useState(false);const[polV,setPolV]=useState([]);
  const[symOn,setSymOn]=useState(false);const[symV,setSymV]=useState([]);
  const[flOn,setFlOn]=useState(false);const[flV,setFlV]=useState([]);
  const[cerOn,setCerOn]=useState(false);const[cerV,setCerV]=useState([]);
  const[stock,setStock]=useState(false);
  const[pairsOnly,setPairsOnly]=useState(false);
  const[sortK,setSortK]=useState('carat');
  const[sortD,setSortD]=useState(true);

  const filtered=raw.filter(p=>{
    const mf=getMF(p),shape=normShape(mf.shape||''),ct=parseCt(mf.carat),pr=p.price;
    if(pairsOnly&&!isPair(p))return false;
    if(shapes.length>0&&!shapes.includes(shape))return false;
    if(ct>0&&(ct<carat[0]||ct>carat[1]))return false;
    if(pr>0&&(pr<price[0]||pr>price[1]))return false;
    if(!colourInRange(colour,mf.colour))return false;
    if(!inRange(CLARITIES,clarity,mf.clarity))return false;
    if(!inRange(CUTS,cut,mf.cut))return false;
    if(polOn&&polV.length>0&&!polV.some(o=>(mf.polish||'').includes(o)))return false;
    if(symOn&&symV.length>0&&!symV.some(o=>(mf.symmetry||'').includes(o)))return false;
    if(flOn&&flV.length>0&&!flV.some(o=>(mf.fluorescence||'').toLowerCase().includes(o.toLowerCase())))return false;
    if(cerOn&&cerV.length>0&&!cerV.some(o=>(mf.certificate||'').includes(o)))return false;
    if(stock&&!mf.in_stock_now)return false;
    return true;
  });

  const sorted=[...filtered].sort((a,b)=>{
    const ma=getMF(a),mb=getMF(b);
    let d=0;
    if(sortK==='price')d=a.price-b.price;
    else if(sortK==='carat')d=parseCt(ma.carat)-parseCt(mb.carat);
    else if(sortK==='colour')d=colourIndex(mb.colour)-colourIndex(ma.colour);
    else if(sortK==='clarity')d=CLARITIES.indexOf(mb.clarity||'I2')-CLARITIES.indexOf(ma.clarity||'I2');
    return sortD?-d:d;
  });

  const reset=()=>{setShapes([]);setCarat([CARAT_MIN,CARAT_MAX]);setPrice([PRICE_MIN,PRICE_MAX]);setColour(null);setClarity(null);setCut(null);setPolOn(false);setPolV([]);setSymOn(false);setSymV([]);setFlOn(false);setFlV([]);setCerOn(false);setCerV([]);setStock(false);setPairsOnly(false);};

  const nActive=[shapes.length>0,carat[0]>CARAT_MIN||carat[1]<CARAT_MAX,price[0]>PRICE_MIN||price[1]<PRICE_MAX,!!colour,!!clarity,!!cut,polOn&&polV.length>0,symOn&&symV.length>0,flOn&&flV.length>0,cerOn&&cerV.length>0,stock,pairsOnly].filter(Boolean).length;

  const advRows=[
    {label:'Polish',hint:'Excellent · Very Good · Good',on:polOn,setOn:v=>{setPolOn(v);if(!v)setPolV([]);},opts:['Excellent','Very Good','Good','Medium'],val:polV,setVal:setPolV},
    {label:'Symmetry',hint:'Excellent · Very Good · Good',on:symOn,setOn:v=>{setSymOn(v);if(!v)setSymV([]);},opts:['Excellent','Very Good','Good'],val:symV,setVal:setSymV},
    {label:'Fluorescence',hint:'None · Faint · Medium · Strong',on:flOn,setOn:v=>{setFlOn(v);if(!v)setFlV([]);},opts:['None','Nil','Faint','Medium','Strong'],val:flV,setVal:setFlV},
    {label:'Certificate',hint:'GIA · DCLA · IGI',on:cerOn,setOn:v=>{setCerOn(v);if(!v)setCerV([]);},opts:['GIA','DCLA','IGI','HRD'],val:cerV,setVal:setCerV}
  ];

  return React.createElement('div',{className:'df-wrap'},
    React.createElement('style',null,CSS),
    React.createElement('div',{className:'df-inner'},

      React.createElement('div',{className:'df-shaperow'},
        React.createElement(Group,{label:'Shape'},
          React.createElement('div',{className:'df-shapes'},
            SHAPES.map(s=>{
              const on=shapes.includes(s);
              return React.createElement('button',{key:s,className:'df-shape'+(on?' on':''),onClick:()=>setShapes(on?shapes.filter(x=>x!==s):[...shapes,s])},
                SHP[s]||SHP.Round,
                React.createElement('span',null,s)
              );
            })
          )
        )
      ),

      React.createElement('div',{className:'df-panel2'},
        React.createElement(Group,{label:'Colour',hint:'D (colourless) → K (light tint) · Fancy = L and below, plus all fancy colours'},
          React.createElement(Scale,{opts:COLORS,value:colour,onChange:setColour,wide:FANCY})
        ),
        React.createElement(Group,{label:'Clarity',hint:'FL (flawless) → I2 (included)'},
          React.createElement(Scale,{opts:CLARITIES,value:clarity,onChange:setClarity})
        )
      ),

      React.createElement('div',{className:'df-panel3'},
        React.createElement(Group,{label:'Cut',hint:'Excellent → Medium'},
          React.createElement(Scale,{opts:CUTS,value:cut,onChange:setCut})
        ),
        React.createElement(Group,{label:'Carat',hint:'Minimum and maximum weight'},
          React.createElement(DualSlider,{min:CARAT_MIN,max:CARAT_MAX,step:0.1,value:carat,onChange:setCarat,fmt:v=>`${v.toFixed(1)}ct`})
        ),
        React.createElement(Group,{label:'Price',hint:'Australian dollars'},
          React.createElement(DualSlider,{min:PRICE_MIN,max:PRICE_MAX,step:1000,value:price,onChange:setPrice,fmt:v=>v===0?'Any':`$${(v/1000).toFixed(0)}k`})
        )
      ),

      React.createElement('div',{className:'df-bar'},
        React.createElement('div',{className:'df-switch'},
          React.createElement(Tog,{on:stock,set:setStock}),
          React.createElement('span',null,'In stock in Sydney')
        ),
        React.createElement('div',{className:'df-switch'},
          React.createElement(Tog,{on:pairsOnly,set:setPairsOnly}),
          React.createElement('span',null,'Matched pairs only')
        ),
        React.createElement('button',{className:'df-btn',onClick:reset},nActive>0?`Reset filters (${nActive})`:'Reset filters'),
        React.createElement('button',{className:'df-btn',onClick:()=>setAdv(a=>!a)},adv?'Advanced filters −':'Advanced filters +'),
        React.createElement('div',{style:{marginLeft:'auto',display:'flex',alignItems:'center',gap:9}},
          loading&&React.createElement('div',{className:'df-loading'},
            React.createElement('div',{className:'df-spinner'}),
            'Loading diamonds…'
          ),
          React.createElement('span',{style:{fontSize:12.5,color:'#a8a296',whiteSpace:'nowrap'}},`${sorted.length} diamond${sorted.length===1?'':'s'}`),
          React.createElement('span',{style:{fontSize:12.5,color:'#a8a296'}},'Sort by:'),
          React.createElement('select',{value:sortK,onChange:e=>setSortK(e.target.value),style:{fontSize:12.5,border:'1.5px solid #d0c8bc',borderRadius:5,padding:'8px 10px',color:'#1a1a2e',background:'white',fontFamily:'inherit',cursor:'pointer',outline:'none'}},
            React.createElement('option',{value:'carat'},'Carat'),
            React.createElement('option',{value:'price'},'Price'),
            React.createElement('option',{value:'colour'},'Colour'),
            React.createElement('option',{value:'clarity'},'Clarity')
          ),
          React.createElement('button',{className:'df-btn',onClick:()=>setSortD(d=>!d),style:{padding:'8px 12px'}},sortD?'↓':'↑')
        )
      ),

      loadError&&React.createElement('div',{className:'df-error'},`Showing a partial list — ${loadError}`),

      adv&&React.createElement('div',{className:'df-adv'},
        React.createElement('div',{className:'df-advgrid'},
          advRows.map(f=>React.createElement('div',{key:f.label},
            React.createElement('div',{className:'df-toggle'},
              React.createElement('div',null,
                React.createElement('div',{style:{fontSize:12.5,fontWeight:500}},f.label),
                React.createElement('div',{style:{fontSize:10.5,color:'#c0b8ac',marginTop:1}},f.hint)
              ),
              React.createElement(Tog,{on:f.on,set:f.setOn})
            ),
            f.on&&React.createElement(Chips,{opts:f.opts,value:f.val,onChange:f.setVal})
          ))
        )
      ),

      sorted.length===0?
        React.createElement('div',{style:{textAlign:'center',padding:'80px 20px'}},
          React.createElement('div',{style:{fontSize:38,marginBottom:14,opacity:.2}},'◇'),
          React.createElement('div',{style:{fontSize:19,fontFamily:"'Cormorant Garamond',serif",marginBottom:8}},loading?'Loading diamonds…':'No diamonds match your filters'),
          !loading&&React.createElement('div',{style:{fontSize:12.5,color:'#a8a296',marginBottom:20}},'Try widening carat, colour or clarity'),
          !loading&&React.createElement('button',{onClick:reset,style:{padding:'10px 24px',background:'#1a1a2e',color:'#d4af37',border:'none',borderRadius:6,fontSize:12,fontWeight:700,cursor:'pointer',fontFamily:'inherit'}},'Reset Filters')
        ):
        React.createElement(React.Fragment,null,
          React.createElement('div',{className:'df-grid'},
            sorted.map((p,i)=>React.createElement('div',{key:p.id,className:'ci',style:{animationDelay:`${Math.min(i*14,220)}ms`}},React.createElement(Card,{p,onClick:()=>setSel(p)})))
          ),
          React.createElement('div',{style:{textAlign:'center',padding:'26px 0 12px',fontSize:10.5,color:'#c0b8ac',letterSpacing:'.06em',textTransform:'uppercase'}},`${sorted.length} diamonds · Diamond Imports Sydney`)
        )
    ),
    sel&&React.createElement(Modal,{p:sel,onClose:()=>setSel(null)})
  );
}

const root=ReactDOM.createRoot(document.getElementById('diamond-finder-root'));
root.render(React.createElement(DiamondFinder));
